import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AppBar from 'material-ui/AppBar';
import { changedUiDrawerVisibility } from '../actions/index';
import AppDrawer from './elements/AppDrawer.jsx';

class Frame extends Component {
  render() {
    return (
      <div className="Frame">
        <AppDrawer />
        <AppBar
          title={this.props.title}
          onClick={() => {
           this.props.changedUiDrawerVisibility(!this.props.uiState.drawerVisibile);
          }}
          onLeftIconButtonTouchTap={() => {
             this.props.changedUiDrawerVisibility(!this.props.uiState.drawerVisibile);
            }}
          onTitleTouchTap={() => {
             this.props.changedUiDrawerVisibility(!this.props.uiState.drawerVisibile);
           }}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    uiState: state.uiState,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    changedUiDrawerVisibility,
  }, dispatch);
}
export default connect(mapStateToProps, matchDispatchToProps)(Frame);



// WEBPACK FOOTER //
// ./src/containers/frame.jsx